export default __webpack_public_path__ + "static/media/Rich Small Cropped.ac8ff7e4.jpg";